import { Navigate, useParams } from 'react-router-dom';
import { getInitialLanguage } from '../i18n';

export default function StoreScopedRedirect({ search = '' }) {
    const { orgSlug, storeSlug } = useParams();
    const lang = getInitialLanguage();
    return (
        <Navigate
            to={`/s/${orgSlug}/${storeSlug}/${lang}${search}`}
            replace
        />
    );
}
